// Carries Meta's ad-click id (fbclid) from the marketing site to the app, so a purchase in the
// app can be matched to the Meta ad that brought the visitor (Sprint 3 step 5).
//
// The site and the app are different domains, so Meta's first-party click cookie (_fbc) set here
// isn't visible on groundworktierup.app. Adding fbclid to links into the app lets the app's own
// Meta Pixel set _fbc there. Google needs nothing extra: the GA4 linker (index.html) already
// carries Google's click and session data across both domains.
const STORAGE_KEY = "gw_fbclid";
const APP_HOSTS = ["groundworktierup.app", "www.groundworktierup.app"];

function remember() {
  try {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (fbclid) window.sessionStorage.setItem(STORAGE_KEY, fbclid);
  } catch {
    // storage blocked - links just go out without it
  }
}

function stored() {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function decorateAppLink(anchor) {
  const fbclid = stored();
  if (!fbclid || !anchor || !anchor.href) return;
  let url;
  try {
    url = new URL(anchor.href);
  } catch {
    return;
  }
  if (!APP_HOSTS.includes(url.hostname) || url.pathname.startsWith("/api/")) return;
  if (url.searchParams.has("fbclid")) return;
  url.searchParams.set("fbclid", fbclid);
  anchor.href = url.toString();
}

if (typeof window !== "undefined") {
  remember();
  // Capture phase, on both mousedown and click, so the id is on the link before the browser
  // follows it (and before GA4's linker adds its own _gl parameter on the same events).
  const handler = (event) => decorateAppLink(event.target && event.target.closest ? event.target.closest("a[href]") : null);
  document.addEventListener("mousedown", handler, true);
  document.addEventListener("click", handler, true);
  document.addEventListener("touchstart", handler, { capture: true, passive: true });
}
